import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M65.97 37.72C65.97 36.72 65.48 35.84 64.73 35.31C65.48 34.78 65.97 33.9 65.97 32.9C65.97 31.81 65.38 30.86 64.51 30.35C65.15 29.81 65.56 29.01 65.56 28.1C65.56 26.87 64.82 25.82 63.78 25.38C64.29 24.85 64.6 24.13 64.6 23.33C64.6 21.95 63.67 20.81 62.41 20.48C62.81 19.97 63.06 19.34 63.06 18.64C63.06 17.11 61.9 15.86 60.43 15.72C60.58 15.36 60.67 14.97 60.67 14.56C60.67 12.93 59.37 11.61 57.76 11.61C57.64 11.61 57.53 11.63 57.42 11.64C57.45 11.46 57.48 11.27 57.48 11.08C57.48 9.45002 56.18 8.13 54.57 8.13C54.27 8.13 53.98 8.19003 53.7 8.28003C53.53 6.82003 52.31 5.67999 50.82 5.67999C50.35 5.67999 49.91 5.80001 49.51 6.01001C49.21 4.71001 48.06 3.72998 46.68 3.72998C46.09 3.72998 45.54 3.91003 45.08 4.22003C44.72 3.01003 43.62 2.13 42.31 2.13C41.61 2.13 40.98 2.39 40.48 2.81C39.99 1.88 39.03 1.23999 37.92 1.23999C37.11 1.23999 36.38 1.58 35.85 2.12C35.33 1.61 34.62 1.28998 33.84 1.28998C33.82 1.28998 33.81 1.29999 33.79 1.29999C33.77 1.29999 33.76 1.28998 33.74 1.28998C32.96 1.28998 32.25 1.61 31.73 2.12C31.2 1.58 30.47 1.23999 29.66 1.23999C28.55 1.23999 27.59 1.88 27.1 2.81C26.6 2.39 25.96 2.13 25.27 2.13C23.96 2.13 22.86 3.02003 22.5 4.22003C22.04 3.91003 21.49 3.72998 20.9 3.72998C19.52 3.72998 18.37 4.70001 18.07 6.01001C17.68 5.81001 17.24 5.67999 16.76 5.67999C15.27 5.67999 14.06 6.82003 13.88 8.28003C13.6 8.19003 13.32 8.13 13.01 8.13C11.4 8.13 10.1 9.45002 10.1 11.08C10.1 11.27 10.12 11.46 10.16 11.64C10.05 11.63 9.94001 11.61 9.82001 11.61C8.21001 11.61 6.91 12.93 6.91 14.56C6.91 14.97 6.98999 15.37 7.14999 15.72C5.67999 15.87 4.51999 17.11 4.51999 18.64C4.51999 19.34 4.77001 19.98 5.17001 20.48C3.91001 20.81 2.98001 21.95 2.98001 23.33C2.98001 24.13 3.29999 24.85 3.79999 25.38C2.74999 25.83 2.01999 26.88 2.01999 28.1C2.01999 29.01 2.43001 29.81 3.07001 30.35C2.20001 30.86 1.60999 31.8 1.60999 32.9C1.60999 33.9 2.10001 34.78 2.85001 35.31C2.10001 35.84 1.60999 36.72 1.60999 37.72C1.60999 38.75 2.13999 39.66 2.92999 40.19C2.45999 40.72 2.16 41.41 2.16 42.18C2.16 43.78 3.42001 45.08 4.98001 45.12C5.50001 47.83 6.04001 49.46 6.04001 49.46L15.72 19.16C15.72 19.16 25.52 17.51 33.79 17.47C42.06 17.5 51.86 19.16 51.86 19.16L61.54 49.46C61.54 49.46 62.08 47.83 62.6 45.12C64.17 45.07 65.42 43.78 65.42 42.18C65.42 41.41 65.12 40.72 64.65 40.19C65.44 39.66 65.97 38.75 65.97 37.72Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.6299 16.98C33.6299 16.98 30.4099 10.6201 22.0699 4.59009"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M16.87 6.12012C16.87 6.12012 21.66 8.10014 29.42 17.0201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.6799 8.68005C13.6799 8.68005 18.1899 10.5001 25.2099 17.6801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M10.27 11.98C10.27 11.98 15.64 13.55 20.76 18.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.04993 15.9501C7.04993 15.9501 11.1799 16.3601 16.2199 19.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5599 22.0601C14.5599 22.0601 9.18994 20.8201 5.30994 20.9901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.4899 26.2702C13.4899 26.2702 7.78991 25.5301 3.90991 25.6901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.2499 30.23C12.2499 30.23 7.12992 29.57 2.91992 30.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M10.93 34.61C10.93 34.61 7.04997 34.57 2.83997 35.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M9.69 38.16L3 40.4701" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M33.84 17.0401C33.84 17.0401 37.06 10.6801 45.4 4.65015"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M41.62 2.71008C41.62 2.71008 37.66 5.52005 33.78 11.3H33.82C29.94 5.52005 25.98 2.71008 25.98 2.71008"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M50.52 6.12012C50.52 6.12012 45.73 8.10014 37.97 17.0201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.7099 8.68005C53.7099 8.68005 49.1999 10.5001 42.1799 17.6801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M57.13 11.98C57.13 11.98 51.76 13.55 46.64 18.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.23 1.58008C37.23 1.58008 35.23 3.29006 33.74 5.69006C32.25 3.30006 30.33 1.58008 30.33 1.58008"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M60.3499 15.9501C60.3499 15.9501 56.2199 16.3601 51.1799 19.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.83 22.0601C52.83 22.0601 58.2 20.8201 62.08 20.9901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.8999 26.2702C53.8999 26.2702 59.5999 25.5301 63.4799 25.6901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M55.14 30.23C55.14 30.23 60.26 29.57 64.47 30.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.46 34.61C56.46 34.61 60.34 34.57 64.55 35.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M57.7 38.16L64.39 40.4701" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
    </g>
  )
}
